import { occupationEcls } from '@juvare/credentialing/backend/constants';
export function getEclLabelByValue(value) {
    var _a;
    return (_a = occupationEcls.find((ecl) => ecl.value === value)) === null || _a === void 0 ? void 0 : _a.label;
}
